import { useTranslation } from 'react-i18next'
import type { PipelineApiError } from '@/lib/api/pipelines.ts'

export function EmptyLeads() {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col items-center justify-center gap-1 px-4 py-10 text-center">
      <span className="text-sm font-medium text-foreground">
        {t('pages.pipelines.empty.title', { defaultValue: 'No deals match these filters' })}
      </span>
      <span className="text-xs text-muted">
        {t('pages.pipelines.empty.body', {
          defaultValue: 'Try clearing the search or expanding the period.',
        })}
      </span>
    </div>
  )
}

/** Distinguishes a failed read from an empty result — never a silent empty board. */
export function LeadsError({ error }: { error: PipelineApiError }) {
  const { t } = useTranslation()
  const body =
    error.kind === 'unauthorized'
      ? t('pages.pipelines.error.unauthorized', {
          defaultValue: 'Session expired — refresh the page and try again.',
        })
      : error.kind === 'network'
        ? t('pages.pipelines.error.network', {
            defaultValue: 'Network error — check your connection and retry.',
          })
        : t('pages.pipelines.error.generic', {
            defaultValue: 'The engine returned an error while loading these leads.',
          })
  return (
    <div
      role="alert"
      className="flex flex-col items-center justify-center gap-1 px-4 py-10 text-center"
    >
      <span className="text-sm font-medium text-toast-error-text">
        {t('pages.pipelines.error.title', { defaultValue: 'Could not load leads' })}
      </span>
      <span className="text-xs text-muted">{body}</span>
      {error.status !== null && (
        <span className="font-mono text-[10px] uppercase tracking-[0.14em] text-muted/70">
          {`HTTP ${error.status} · ${error.message}`}
        </span>
      )}
    </div>
  )
}

export function LeadsLoading() {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col items-center justify-center gap-1 px-4 py-10 text-center">
      <span className="text-sm font-medium text-muted">
        {t('pages.pipelines.loading', { defaultValue: 'Loading deals…' })}
      </span>
    </div>
  )
}
